import { ReservationType } from "@/lib/gql/__generated__/graphql";

import { convertRequiredPrepMillisecondIntoRequiredPrepMillisecondBeforeDateAndHour } from "@/components/features/_shared/validation-schema/converter";

import type { AccommodationHotelPolicyFormModel } from "../../../../type";
import type { ServerModel } from "../../type";

type Props = {
	serverModel: ServerModel;
};

export const serverModelToInputModelConverter = ({
	serverModel,
}: Props): AccommodationHotelPolicyFormModel["InputModel"] | undefined => {
	const { hotelPolicy, hotelDisplaySettings } = serverModel;

	if (!hotelPolicy) return undefined;

	const requiredPrepMillisecond: number = hotelPolicy.requiredPrepMillisecond;
	const { requiredPrepMillisecondBeforeDate, requiredPrepMillisecondBeforeHour } =
		convertRequiredPrepMillisecondIntoRequiredPrepMillisecondBeforeDateAndHour(requiredPrepMillisecond);

	const viewModel: AccommodationHotelPolicyFormModel["InputModel"] = {
		amenities: hotelPolicy.amenities,
		calcAdultPriceAsTotalNum: hotelPolicy.calcAdultPriceAsTotalNum,
		cancelPolicy: hotelPolicy.cancelPolicy,
		checkInEnd: hotelPolicy.checkInEnd,
		checkInStart: hotelPolicy.checkInStart,
		checkOut: hotelPolicy.checkOut,
		facilities: hotelPolicy.facilities,
		hotelInfo: hotelPolicy.hotelInfo,
		id: hotelPolicy.id,
		kidsCosleepingPolicy: hotelPolicy.kidsCosleepingPolicy ?? undefined,
		kidsPolicy: hotelPolicy.kidsPolicy
			? (hotelPolicy.kidsPolicy?.map((item) => ({
					...item,
					static: item.static
						? {
								amount: item.static.amount,
								currencyType: item.static.currencyType,
							}
						: undefined,
				})) as AccommodationHotelPolicyFormModel["InputModel"]["kidsPolicy"])
			: [],
		additionalFees: hotelPolicy.additionalFees,
		isShowRoomPriceInCalender: hotelPolicy.isShowRoomPriceInCalender,
		isShowPlanIncludedPrice: hotelPolicy.isShowPlanIncludedPrice,
		isShowBestRateNotice: hotelPolicy.isShowBestRateNotice,
		isCalendarStartFromAvailableMonth: hotelPolicy.isCalendarStartFromAvailableMonth,
		isShowCheckInOutTime: hotelDisplaySettings.isShowCheckInOutTime,
		bookedGuestSurveyDisplayStatus: hotelDisplaySettings.bookedGuestSurveyDisplayStatus,
		defaultPlanID: hotelPolicy.defaultPlanID ?? null,
		defaultInitPeopleNum: hotelPolicy.defaultInitPeopleNum,

		baseReservationType: hotelPolicy.baseReservationType ?? ReservationType.Normal,

		hideMailMagazineQuestion: hotelPolicy.hideMailMagazineQuestion,
		isLocalPaymentAvailable: hotelPolicy.isLocalPaymentAvailable,

		localPaymentCancelFeeTransferInfo: hotelPolicy.localPaymentCancelFeeTransferInfo ?? undefined,

		localPaymentCancelFeeTransferLimitDays: {
			limitDays: hotelPolicy.localPaymentCancelFeeTransferLimitDays ?? 7,
		},

		questions: hotelPolicy.questions,

		requiredPlanSelectForReservation: hotelPolicy.requiredPlanSelectForReservation,

		requiredPrepMillisecond,
		requiredPrepMillisecondBeforeDate,
		requiredPrepMillisecondBeforeHour,
	} satisfies AccommodationHotelPolicyFormModel["InputModel"];

	return viewModel;
};
